<form class="row align-items-center" [formGroup]="searchForm">
  <mat-form-field
    appearance="outline"
    class="mat-form-field-fluid col-md-12"
    [ngClass]="{ 'gl-block': filt && filt.param && filt.param === 'patient' }"
  >
    <mat-label>{{ filt.param }}</mat-label>
    <input
      matInput
      [matAutocomplete]="autoFilter"
      (ngModelChange)="
        filterInputChanged(filterInput.value, filt.autocomplete_url, filt.search_param)
      "
      #filterInput
      formControlName="filterControl"
      (keydown.backspace)="remove(filt.param)"
      (keydown.delete)="remove(filt.param)"
    />
    <mat-icon matSuffix>arrow_drop_down</mat-icon>
    <mat-autocomplete
      autoActiveFirstOption
      #autoFilter="matAutocomplete"
      (optionSelected)="selectedFilter($event, filt.display, filt.param)"
      [displayWith]="displayFnFilter"
    >
      <mat-option *ngFor="let filter of filteredFilter | async" [value]="filter">
        {{ getName(filter, filt.display) }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
